import axios from 'axios'
// import qs from 'qs'
import Vue from 'vue'
import { Dialog } from 'vant'
import router from '@/router'
import Cookie from 'js-cookie'

Vue.use(Dialog)
// import {
//   Message
// } from 'element-ui'

// const is_production = process.env.NODE_ENV == 'production'

// axios.defaults.timeout = 10000

const _axios = axios.create({
  baseURL: '/',
  timeout: 10000,
  withCredentials: true,
})

_axios.interceptors.response.use(
  res => {
    if (res.data.errorCode == 10042 || res.data.errorCode == 10032 || res.data.errorCode == 10033) {
      setTimeout(() => {
        router.push('/login')
      }, 2000)
    } else if (res.data.errorCode != 0) {
      Dialog.alert({
        title: '提示',
        message: res.data.errorMsg
      })
    }
    return res
    // Message(_data.msg || '服务器响应错误')
    
    // if(_data.msg == 'Token已失效') {
    //   setTimeout(() => {
    //     router.push('/login')
    //   }, 2000)
    // }
  },
  err => {
    try {
      const err_code = err.response.status
      switch (err_code) {
        case 401:
          // 登录过期 ,2秒后跳转
          setTimeout(() => {
            router.push('/login')
          }, 2000)
          break;
        case 500:
          break;
      }
    } catch (err) {
      // console.log(1)
    }
  }
)

_axios.interceptors.request.use(
  config => {
    // if (is_production) config.url = proxy_handle(config.url)
    config.headers['token'] = Cookie.get('token')
    config.params = {
      ...config.params
    }
    //config.query['lang'] = 'zh_CN'
    // if (config.method == 'post') {
    //   config.data = qs.stringify(config.data)
    // }
    
    return config
  }
)

// 生产环境代理处理
// function proxy_handle(url) {
//   console.log(999)
//   const pathArr = url.split('/')
//   pathArr.splice(1, 1)
//   return '/lss/api/v1' + pathArr.join('/')
// }

export default _axios